<template lang="pug">
  v-layout.justify-space-between(:class="{ 'choice-load': isChoice }")
    v-flex.xs4
      div(data-test="layerCategoryList")
        v-layout.column.category-wrapper.scroll-y-overflow.pl-2
          v-flex(v-for="category in categories" :key="category.categoryId")
            div.pt-3.pb-2.pr-2.subheading.category(
              v-if="category.name !== 'Partenaires'"
              data-test="layerCategory"
              @click="selectedCategory = category"
              :class="{ 'selected-category': selectedCategory === category, choice: isChoice }"
            ) {{ category.name }}
    v-flex.xs8
      div.pr-3(v-if="selectedCategory && config" data-test="layerList")
        v-layout.pl-5.pb-2.justify-end
          .subheading.underline.click.mr-3(@click="changeAll(true)") Tout cocher
          .subheading.underline.click(@click="changeAll(false)") Tout décocher
        v-layout.column.justify-start
          v-flex.pl-5.override-flex(v-for="layer in orderedIcons" :key="layer.name")
            v-layout.align-center.justify-space-between
              v-checkbox.mt-0.pt-2.pb-1(
                :label="layer.name" data-test="layer"
                hide-details :color="color"
                :input-value="!config.icons || !config.icons.disabled.includes(layer.id)"
                @change="(value) => { changeLayer(value, layer.id, 'icons') }"
              )
              v-img(
                v-if="layer.icon" :height="32" :max-width="32" :width="32" :aspect-ratio="1"
                :src="'/v1/static/icons/' + layer.icon + '.png'"
              )
          v-flex.pl-5.override-flex(v-for="layer in selectedCategory.elements" :key="layer.layerId")
            v-layout.align-center.justify-space-between
              v-checkbox.mt-0.pt-2.pb-1(
                :label="layer.name" data-test="layer"
                hide-details :color="color"
                v-if="config.elements"
                :input-value="!config.elements || !config.elements.disabled.includes(layer.id)"
                @change="(value) => { changeLayer(value, layer.id, 'elements') }"
              )
              v-img(
                v-if="layer.icon" :height="32" :max-width="32" :aspect-ratio="1"
                :src="'/v1/static/icons/' + layer.icon + '.png'"
              )
</template>

<script>
import mixin from '@/mixins/Rc.mixin.vue';

export default {
  props: {
    config: Object,
  },
  mixins: [mixin],
  data() {
    return {
      loading: false,
      selectedCategory: null,
    };
  },
  watch: {
    config() {
      this.transientParams = this.filterConfig(this.config);
    },
  },
  mounted() {
    this.$store.dispatch('layers/getCategories').then(() => {
      [this.selectedCategory] = this.categories;
    });
  },
  methods: {
    changeAll(value) {
      if (this.selectedCategory.icons) {
        this.selectedCategory.icons.map(it => this.changeLayer(value, it.id, 'icons'));
      }
      if (this.selectedCategory.elements) {
        this.selectedCategory.elements.map(it => this.changeLayer(value, it.id, 'elements'));
      }
    },
    changeLayer(value, id, type) {
      this.loading = true;
      if (this.config[type].disabled === undefined) {
        this.config[type].disabled = [];
      }
      let beforeLayers = this.config[type].disabled;
      if (!value) {
        beforeLayers.push(id);
      } else {
        beforeLayers = this.config[type].disabled.filter(x => x !== id);
      }
      this.config[type].disabled = beforeLayers;
      this.transientParams = this.filterConfig(this.config);
      this.$emit('changed', this.transientParams);
    },
  },
  computed: {
    categories() {
      return this.$store.state.layers.categories;
    },
    orderedIcons() {
      if (this.selectedCategory.icons) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        return this.selectedCategory.icons.sort((a, b) => {
          if (a.name < b.name) return -1;
          if (a.name > b.name) return 1;
          return 0;
        });
      }
      return this.selectedCategory.icons;
    },
    isChoice() {
      return this.$route.query.context === 'choice';
    },
    color() {
      return this.isChoice ? '#e75239' : 'primary';
    },
  },
};
</script>

<style lang="scss" scoped>
  .override-flex {
    flex: 0!important;
  }
  .category {
    transition: all 0.1s linear;
    &.selected-category {
      border-bottom: 2px solid #e75239;
    }
    &:not(.selected-category) {
      cursor: pointer;
      &:hover {
        background-color: lighten(#e75239, 40%);
      }
    }
  }
</style>
